export default [
  {
    title: 'Last update',
    date: '23.10.2023',
  },
  {
    title: 'Team ',
    date: 'Guardnet Developer Team',
    
    
  },
  {
    title: 'Owner',
    date: 'İbrahim Sevgili',
    
  },
  {
    title: 'Owner Email',
    date: 'info@guardnet.com.tr',
    
  }
];
